import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Icon } from "@ann/web-components";
import { HeaderContainer, TitleContainer, IconWrapper } from "./Header.styled";

const Header = ({ title, description }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/v2/user-management");
  };

  return (
    <HeaderContainer>
      {title && (
        <TitleContainer>
          <IconWrapper onClick={handleBackClick}>
            <Icon name="arrowLeft" size="medium" />
          </IconWrapper>
          <Typography category="title" size="large" weight="bold">
            {title}
          </Typography>
        </TitleContainer>
      )}
      {description && (
        <Typography category="body" size="medium" weight="regular">
          {description}
        </Typography>
      )}
    </HeaderContainer>
  );
};

export default Header;

